import React from 'react'

export const ContactComponent = () => {
  return (
    <div className="contact-whatsapp">
      <a href="https://wa.me/50258507070">
        <img src="../assets/wa.png" alt="WhatsApp" />
      </a>
    </div>
  )
}
